import React, { useState, useEffect, useRef, use } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
    Container, TextField, Button, Typography, Link as MuiLink, Table, TableBody, TableCell, TableContainer, Checkbox, FormControl, InputLabel,
    TableHead, Box, TableRow, Paper, Snackbar, Alert, TablePagination, Tooltip, CircularProgress, Backdrop, Select, MenuItem, Dialog, DialogTitle,
    DialogContent, DialogActions, Tabs, Tab
} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { Delete, Edit, FileCopyTwoTone, FileUpload, Info } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { TableSortLabel } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { collection, getDocs, getDoc, deleteDoc, doc, where, query, orderBy, addDoc, getCountFromServer, startAfter, endBefore, limitToLast, limit } from 'firebase/firestore';
import { db } from '../../config/firebase';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import { auth } from '../../config/firebase';
import getIdToken from '../../components/getIdToken';
import Cancel from '@mui/icons-material/Cancel';
import moment from 'moment';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useMediaQuery, useTheme } from '@mui/material';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import StatusIndicator from '../../components/StatusIndicator';
import { filter } from 'lodash';

const Domains = () => {
    const [domains, setDomains] = useState([]);
    const [originalDomains, setOriginalDomains] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [domainToDelete, setDomainToDelete] = useState(null);
    const [selectedDomains, setSelectedDomains] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortColumn, setSortColumn] = useState('creationTime');
    const [sortOrder, setSortOrder] = useState('desc');
    const [action, setAction] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const navigate = useNavigate();
    const [groupIdFromUrl, setGroupIdFromUrl] = useState('');
    const [templateFromUrl, setTemplateFromUrl] = useState('');
    const [keywordFromUrl, setKeywordFromUrl] = useState('');
    const [projectFromUrl, setProjectFromUrl] = useState('');
    const [domainSearch, setDomainSearch] = useState('');
    const [userEmailSearch, setUserEmailSearch] = useState('');
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [hoveredDomainId, setHoveredDomainId] = useState(null);
    const [keywordSearch, setKeywordSearch] = useState('');
    const [projectSearch, setProjectSearch] = useState('');
    const [templateSearch, setTemplateSearch] = useState('');
    const [siteNameSearch, setSiteNameSearch] = useState('');
    const [creationTimeSearch, setCreationTimeSearch] = useState('');
    const [creationTimeFrom, setCreationTimeFrom] = useState('');
    const [creationTimeTo, setCreationTimeTo] = useState('');
    const [dateError, setDateError] = useState('');
    const [domainInput, setDomainInput] = useState('');
    const [userEmailInput, setUserEmailInput] = useState('');
    const [keywordInput, setKeywordInput] = useState('');
    const [projectInput, setProjectInput] = useState('');
    const [templateInput, setTemplateInput] = useState('');
    const [siteNameInput, setSiteNameInput] = useState('');
    const [creationTimeFromInput, setCreationTimeFromInput] = useState('');
    const [creationTimeToInput, setCreationTimeToInput] = useState('');
    const [lastVisible, setLastVisible] = useState(null);
    const [firstVisible, setFirstVisible] = useState(null);
    const [totalQuery, setTotalQuery] = useState(null);
    const [paginatedDomains, setPaginatedDomains] = useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();
    const [domainStatuses, setDomainStatuses] = useState({});
    const [loading, setLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const hasSetPageRef = useRef(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [summaryData, setSummaryData] = useState(null);
    const [allSelectedDomains, setAllSelectedDomains] = useState([]);
    const [selectedTab, setSelectedTab] = useState(1);
    const [selectedRegion, setSelectedRegion] = useState("ca_toronto");

    const fetchData = async ({
        lastVisible = null,
        firstVisible = null,
        rowsPerPage = 10,
        filters = {},
        sortColumn = "creationTime",
        sortOrder = "desc",
        direction = "" // "next" or "prev"
    }) => {
        const { domainSearch, userEmailSearch, siteNameSearch, creationTimeFrom, creationTimeTo } = filters;
        setLoading(true);

        try {
            const user = auth.currentUser;
            if (!user) return;

            const userId = user.uid;
            const urlParams = new URLSearchParams(window.location.search);
            const urlFilters = {
                domain: urlParams.get('domain') || '',
                email: urlParams.get('email') || '',
                // siteName: urlParams.get('siteName') || '',
                creationTimeFrom: urlParams.get('creationTimeFrom') || '',
                creationTimeTo: urlParams.get('creationTimeTo') || ''
            };

            // fetch userId by email
            let searchUid = null;
            if (urlFilters.email || userEmailSearch) {
                const userEmail = (userEmailSearch || urlFilters.email)?.toLowerCase().trim();
                const q = query(collection(db, "users"), where("email", "==", userEmail));
                const snap = await getDocs(q);
                if (!snap.empty) searchUid = snap.docs[0].id;
            }

            const startDate = creationTimeFrom || urlFilters.creationTimeFrom
                ? new Date(creationTimeFrom || urlFilters.creationTimeFrom)
                : new Date('2024-04-01');
            const endDate = creationTimeTo || urlFilters.creationTimeTo
                ? new Date(creationTimeTo || urlFilters.creationTimeTo)
                : new Date();
            endDate.setHours(23, 59, 59, 999);

            let queryRef = query(
                collection(db, 'domains'),
                where('creationTime', '>=', startDate),
                where('creationTime', '<=', endDate)
            );

            if (sortColumn) queryRef = query(queryRef, orderBy(sortColumn, sortOrder));
            if (searchUid) queryRef = query(queryRef, where('userId', '==', searchUid));
            if (domainSearch || urlFilters.domain) {
                const searchDomainName = (domainSearch || urlFilters.domain).toLowerCase().trim();
                console.log(searchDomainName, typeof searchDomainName);

                queryRef = query(queryRef, where('domainName', '==', searchDomainName));
            }

            const totalQuery = queryRef;
            setTotalQuery(totalQuery);

            // pagination
            if (direction === "next" && lastVisible) {
                const lastDocRef = doc(db, "domains", lastVisible);
                const lastDocSnap = await getDoc(lastDocRef);
                if (lastDocSnap.exists()) queryRef = query(queryRef, startAfter(lastDocSnap), limit(rowsPerPage));
            } else if (direction === "prev" && firstVisible) {
                const firstDocRef = doc(db, "domains", firstVisible);
                const firstDocSnap = await getDoc(firstDocRef);
                if (firstDocSnap.exists()) queryRef = query(queryRef, endBefore(firstDocSnap), limitToLast(rowsPerPage));
            } else {
                queryRef = query(queryRef, limit(rowsPerPage));
            }

            const domainSnapshot = await getDocs(queryRef);
            let displayDomains = domainSnapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    creationTime: data.creationTime instanceof Date
                        ? data.creationTime
                        : data.creationTime?.toDate ? data.creationTime.toDate() : new Date(),
                };
            });

            setOriginalDomains(displayDomains);
            const firstVisibleDoc = domainSnapshot.docs[0] || null;
            const lastVisibleDoc = domainSnapshot.docs[domainSnapshot.docs.length - 1] || null;
            setFirstVisible(firstVisibleDoc?.id || null);
            setLastVisible(lastVisibleDoc?.id || null);


            setAllSelectedDomains(prev => {
                const map = new Map(prev.map(d => [d.id, d]));

                displayDomains.forEach(d => {
                    map.set(d.id, d); // overwrite if exists
                });

                return Array.from(map.values());
            });
            setPaginatedDomains(displayDomains);
            setDomains(displayDomains);

            const totalSnap = await getCountFromServer(totalQuery);
            setTotalCount(totalSnap.data().count);

        } catch (error) {
            console.error("Error fetching domains: ", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (originalDomains) {
            const userIds = [...new Set(originalDomains.map(d => d.userId))];
            combineUserEmails(userIds);
        }

    }, [originalDomains])

    const combineUserEmails = async (userIds) => {
        const userEmails = await batchFetchUserEmails(userIds);

        const combinedDomains = originalDomains.map(domain => ({
            ...domain,
            userEmail: userEmails[domain.userId] || 'Unknown Email',
        }));

        setAllSelectedDomains(prev => {
            const map = new Map(prev.map(d => [d.id, d]));

            combinedDomains.forEach(d => {
                map.set(d.id, d); // overwrite if exists
            });

            return Array.from(map.values());
        });
        setPaginatedDomains(combinedDomains);
        setDomains(combinedDomains);
    }

    const batchFetchUserEmails = async (userIds) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_CLOUD_FUNCTION_BASE_URL}getUserEmails`, {
                method: "POST",
                headers: { Authorization: `Bearer ${await getIdToken()}`, "Content-Type": "application/json" },
                body: JSON.stringify({ uids: userIds }),
            });
            if (response.ok) {
                return await response.json(); // Returns the email map
            } else {
                console.error("Failed to fetch user emails:", response.statusText);
                return {};
            }
        } catch (error) {
            console.error("Error in batchFetchUserEmails:", error);
            return {};
        }
    };
    
    const fetchAllDomainIds = async () => {
        const user = auth.currentUser;
        if (user) {
            const userId = user.uid;
            const querySnapshot = await getDocs(totalQuery);

            const domains = querySnapshot.docs.map(doc => ({
                id: doc.id, 
                ...doc.data(), 
            }));
            setAllSelectedDomains(domains);

            return querySnapshot.docs.map(doc => doc.id);
        }
        return [];
    };

    const handleSearch = () => {
        setDomainSearch(domainInput);
        setUserEmailSearch(userEmailInput);
        setKeywordSearch(keywordInput);
        setProjectSearch(projectInput);
        setTemplateSearch(templateInput);
        setSiteNameSearch(siteNameInput);
        setCreationTimeFrom(creationTimeFromInput);
        setCreationTimeTo(creationTimeToInput);

        // Update the URL parameters
        const queryParams = new URLSearchParams();
        if (domainInput) queryParams.set('domain', domainInput);
        if (userEmailInput) queryParams.set('email', userEmailInput);
        if (keywordInput) queryParams.set('keyword', keywordInput);
        if (projectInput) queryParams.set('project', projectInput);
        if (templateInput) queryParams.set('template', templateInput);
        if (siteNameInput) queryParams.set('siteName', siteNameInput);
        if (creationTimeFromInput) queryParams.set('creationTimeFrom', creationTimeFromInput);
        if (creationTimeToInput) queryParams.set('creationTimeTo', creationTimeToInput);
        // queryParams.set('page', 1);  // Reset to page 1 after search
        navigate({ search: queryParams.toString() });
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const groupIdFromUrl = queryParams.get('group') || '';
        const templateFromUrl = queryParams.get('template') || '';
        const projectFromUrlParam = queryParams.get('project') || '';
        const keywordFromUrlParam = queryParams.get('keyword') || '';

        setGroupIdFromUrl(groupIdFromUrl);
        setTemplateFromUrl(templateFromUrl);
        setProjectFromUrl(projectFromUrlParam);
        setKeywordFromUrl(keywordFromUrlParam);
        setDomainInput(queryParams.get('domain') || '');
        setUserEmailInput(queryParams.get('email') || '');
        setKeywordInput(queryParams.get('keyword') || '');
        setProjectInput(queryParams.get('project') || '');
        setTemplateInput(queryParams.get('template') || '');
        setSiteNameInput(queryParams.get('siteName') || '');
        setCreationTimeFromInput(queryParams.get('creationTimeFrom') || '');
        setCreationTimeToInput(queryParams.get('creationTimeTo') || '');

        let pageQuery = queryParams.get('page') || '1';

        queryParams.delete('page');
        const queryParamsToKeep = {};
        queryParams.forEach((value, key) => {
            if (value) {
                queryParamsToKeep[key] = value;
            }
        });

        let newUrlParams = new URLSearchParams(queryParamsToKeep).toString();
        // newUrlParams += `&page=${pageQuery}`;
        const finalUrl = `${location.pathname}?${newUrlParams}`;
        if (location.search !== `?${newUrlParams}`) {
            navigate(finalUrl, { replace: true });
        }

        // const pageParam = parseInt(pageQuery, 10) || 1;
        // setPage(pageParam - 1);
    }, [location.search, navigate]);

    useEffect(() => {
        const savedRowsPerPage = localStorage.getItem('rowsPerPage');

        const queryParams = new URLSearchParams(window.location.search);
        const sortColumnFromUrl = queryParams.get('sortColumn') || 'creationTime'; // Default column
        const sortOrderFromUrl = queryParams.get('sortOrder') || 'desc'; // Default order

        setSortColumn(sortColumnFromUrl);
        setSortOrder(sortOrderFromUrl);

        const filters = {
            domainSearch: queryParams.get('domain') || '',
            userEmailSearch: queryParams.get('email') || '',
            // keywordSearch: queryParams.get('keyword') || '',
            // projectSearch: queryParams.get('project') || '',
            // templateSearch: queryParams.get('template') || '',
            siteNameSearch: queryParams.get('siteName') || '',
            creationTimeFrom: queryParams.get('creationTimeFrom') || '',
            creationTimeTo: queryParams.get('creationTimeTo') || '',
        };

        // const pageParam = parseInt(queryParams.get('page'), 10) || 1;
        fetchData({
            lastVisible,
            firstVisible,
            rowsPerPage: savedRowsPerPage || 10,
            filters,
            sortColumn: sortColumnFromUrl,
            sortOrder: sortOrderFromUrl,
            direction: ''
        });
    }, [location.search, rowsPerPage]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        // const pageParam = parseInt(queryParams.get('page'), 10);
        const templateParam = queryParams.get('template');
        const projectParam = queryParams.get('project');
        const keywordParam = queryParams.get('keyword');

        if (templateParam) {
            setTemplateFromUrl(templateParam);
        }

        if (projectParam) {
            setProjectFromUrl(projectParam);
        }

        if (keywordParam) {
            setKeywordFromUrl(keywordParam);
        }

        // if (!isNaN(pageParam) && pageParam > 0) {
        //     const pageIndex = pageParam - 1;
        // setPage(pageIndex);
        // } else {
        // setPage(0);
        // }
    }, [location.search, totalCount, rowsPerPage, page]);

    useEffect(() => {
        // Save sortColumn and sortOrder to localStorage
        if (sortColumn) {
            localStorage.setItem('sortColumn', sortColumn);
        }
        if (sortOrder) {
            localStorage.setItem('sortOrder', sortOrder);
        }
    }, [sortColumn, sortOrder]);

    //GroupIdFromUrl
    // useEffect(() => {
    //     if (groupIdFromUrl) {
    //         const queryParams = new URLSearchParams(location.search);
    //         if (queryParams.get('group') !== groupIdFromUrl) {
    //             navigate(`../domains?group=${groupIdFromUrl}&page=${page + 1}`);
    //         }
    //     }
    // }, [groupIdFromUrl, page, navigate]);

    //templateFromURL
    // useEffect(() => {
    //     if (templateFromUrl) {
    //         const queryParams = new URLSearchParams(location.search);
    //         if (queryParams.get('template') !== templateFromUrl) {
    //             navigate(`../domains?template=${templateFromUrl}&page=${page + 1}`);
    //         }
    //     }
    // }, [templateFromUrl, page, navigate]);

    // //keywordFromUrl
    // useEffect(() => {
    //     if (keywordFromUrl) {
    //         const queryParams = new URLSearchParams(location.search);
    //         if (queryParams.get('keyword') !== keywordFromUrl) {
    //             navigate(`../domains?keyword=${keywordFromUrl}&page=${page + 1}`);
    //         }
    //     }
    // }, [keywordFromUrl, page, navigate]);

    //projectFromUrl
    // useEffect(() => {
    //     if (projectFromUrl) {
    //         const queryParams = new URLSearchParams(location.search);
    //         if (queryParams.get('project') !== projectFromUrl) {
    //             navigate(`../domains?project=${projectFromUrl}&page=${page + 1}`);
    //         }
    //     }
    // }, [projectFromUrl, page, navigate]);

    useEffect(() => {
        if (location.state && location.state.snackbarMessage) {
            setSnackbarMessage(location.state.snackbarMessage);
            setSnackbarOpen(true);
        }
    }, [location.state]);

    const checkDomainStatus = async (domain) => {
        try {
            setDomainStatuses(prevStatuses => ({
                ...prevStatuses,
                [domain.id]: { status: 'loading' }
            }));

            // Fetch the domain settings from the database
            const domainRef = doc(db, 'domains', domain.id);
            const domainDoc = await getDoc(domainRef);
            const domainData = domainDoc.data();
            const regions = domainData.uptime_settings.regions || [
                { city: "toronto", country: "ca" },
                { city: "shenzhen", country: "cn" },
            ];
            const upStatuses = domainData.uptime_settings.upStatuses || ["2xx", "3xx"];
            const follow_redirect = domainData.uptime_settings?.followRedirect || false;
            const request_timeout = domainData.uptime_settings?.requestTimeout || 10;
            const response = await axios.post(`${process.env.REACT_APP_CLOUD_FUNCTION_BASE_URL}checkDomainStatus`, {
                domains: {
                    [domainData.domainName]: { regions, upStatuses, follow_redirect, request_timeout },
                },
            }, {
                params: { domain: domainData.domainName, url: domain.urlToMonitor || domainData.domainName },
                // checkDomainStatus refuses a caller without a Firebase ID token (seoweb functions/callerAuth.js).
                headers: { Authorization: `Bearer ${await getIdToken()}` },
            });

            const { regionStatuses } = response.data;
            const upCount = Object.values(regionStatuses).filter(r => r.status === "Online").length;
            const totalRegions = Object.keys(regionStatuses).length;

            setDomainStatuses(prevStatuses => ({
                ...prevStatuses,
                [domain.id]: { status: 'loaded', regionStatuses, upCount, totalRegions }
            }));
        } catch (error) {
            console.error("Error fetching domain status: ", error);
            setDomainStatuses(prevStatuses => ({
                ...prevStatuses,
                [domain.id]: { status: 'error' }
            }));
        }
    };

    const checkDomainsStatus = async () => {
        const domainPromises = domains.map(domain => checkDomainStatus(domain));
        await Promise.all(domainPromises);
    };

    const handleStatusClick = async (domain) => {
        try {
            setDomainStatuses(prevStatuses => ({
                ...prevStatuses,
                [domain.id]: { status: 'loading' }
            }));

            // Fetch the domain settings from the database
            const domainRef = doc(db, 'domains', domain.id);
            const domainDoc = await getDoc(domainRef);
            const domainData = domainDoc.data();

            // Extract regions and upStatuses
            const regions = domainData.uptime_settings.regions || [
                { city: "toronto", country: "ca" },
                { city: "shenzhen", country: "cn" },
            ];
            const upStatuses = domainData.uptime_settings.upStatuses || ["2xx", "3xx"];
            const follow_redirect = domainData.uptime_settings?.followRedirect || false;
            const request_timeout = domainData.uptime_settings?.requestTimeout || 10;
            const response = await axios.post(`${process.env.REACT_APP_CLOUD_FUNCTION_BASE_URL}checkDomainStatus`, {
                domains: {
                    [domainData.domainName]: { regions, upStatuses, follow_redirect, request_timeout },
                },
            }, {
                params: { domain: domainData.domainName, url: domain.urlToMonitor || domainData.domainName },
                // checkDomainStatus refuses a caller without a Firebase ID token (seoweb functions/callerAuth.js).
                headers: { Authorization: `Bearer ${await getIdToken()}` },
            });

            const { regionStatuses } = response.data;
            const upCount = Object.values(regionStatuses).filter(r => r.status === "Online").length;
            const totalRegions = Object.keys(regionStatuses).length;

            setDomainStatuses(prevStatuses => ({
                ...prevStatuses,
                [domain.id]: { status: 'loaded', regionStatuses, upCount, totalRegions }
            }));
        } catch (error) {
            console.error("Error fetching domain status: ", error);
            setDomainStatuses(prevStatuses => ({
                ...prevStatuses,
                [domain.id]: { status: 'error' }
            }));
        }
    };

    useEffect(() => {
        checkDomainsStatus();
    }, [domains]);

    const handleChangePage = async (event, newPage) => {
        setPage(newPage);
        if (newPage > page) {
            fetchData({
                lastVisible: lastVisible,
                rowsPerPage: rowsPerPage,
                direction: "next"
            });
        } else {
            fetchData({
                firstVisible: firstVisible,
                rowsPerPage: rowsPerPage,
                direction: "prev"
            });
        }
    };

    // const handleChangePage = async (event, newPage) => {
    //     setPage(newPage);
    //     const queryParams = new URLSearchParams();
    //     if (groupIdFromUrl) queryParams.set('group', groupIdFromUrl);
    //     if (templateFromUrl) queryParams.set('template', templateFromUrl);
    //     if (keywordFromUrl) queryParams.set('keyword', keywordFromUrl);
    //     if (projectFromUrl) queryParams.set('project', projectFromUrl);
    //     if (domainInput) queryParams.set('domain', domainInput);
    //     if (userEmailInput) queryParams.set('email', userEmailInput);
    //     if (siteNameInput) queryParams.set('siteName', siteNameInput);
    //     if (creationTimeFromInput) queryParams.set('creationTimeFrom', creationTimeFromInput);
    //     if (creationTimeToInput) queryParams.set('creationTimeTo', creationTimeToInput);
    //     if (sortColumn) queryParams.set('sortColumn', sortColumn);
    //     if (sortOrder) queryParams.set('sortOrder', sortOrder);
    //     queryParams.set('page', newPage + 1);
    //     navigate(`../domains?${queryParams.toString()}`);
    // };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        const queryParams = new URLSearchParams();
        if (groupIdFromUrl) queryParams.set('group', groupIdFromUrl);
        if (templateFromUrl) queryParams.set('template', templateFromUrl);
        if (keywordFromUrl) queryParams.set('keyword', keywordFromUrl);
        if (userEmailInput) queryParams.set('email', userEmailInput);
        if (projectFromUrl) queryParams.set('project', projectFromUrl);
        if (domainInput) queryParams.set('domain', domainInput);
        if (siteNameInput) queryParams.set('siteName', siteNameInput);
        if (creationTimeFromInput) queryParams.set('creationTimeFrom', creationTimeFromInput);
        if (creationTimeToInput) queryParams.set('creationTimeTo', creationTimeToInput);
        navigate(`../domains?${queryParams.toString()}`);
        localStorage.setItem('rowsPerPage', newRowsPerPage);
    };

    useEffect(() => {
        const savedRowsPerPage = localStorage.getItem('rowsPerPage');
        if (savedRowsPerPage) {
            setRowsPerPage(savedRowsPerPage);
        }

        return () => {
            localStorage.removeItem('rowsPerPage');
        };
    }, []);

    const handleDelete = async (domainIds) => {
        setIsDeleting(true);
        try {
            // Ensure keywordIds is an array
            if (!Array.isArray(domainIds)) {
                domainIds = [domainIds];
            }

            for (let domainId of domainIds) {
                // If no associated domains, delete the keyword.
                await deleteDoc(doc(db, 'domains', domainId));
            }

            setSnackbarMessage(domainIds.length > 1
                ? 'Selected Domains have been deleted successfully.'
                : 'Domain has been deleted successfully.');
            setSnackbarOpen(true);

            setDomains(prevDomains => prevDomains.filter(domain => !domainIds.includes(domain.id)));
            setPaginatedDomains(prevDomains => prevDomains.filter(domain => !domainIds.includes(domain.id)));
            setSelectedDomains([]);

            setConfirmDialogOpen(false);
        } catch (error) {
            console.error("Error deleting domain: ", error);
            setSnackbarMessage('An error occurred. Please try again.');
            setSnackbarOpen(true);
        } finally {
            setIsDeleting(false);
        }
    };

    const handleConfirmDelete = () => {
        if (selectedDomains.length > 0) {
            handleDelete(selectedDomains);
        } else {
            handleDelete(domainToDelete);
        }
    };
    
    const handleApplyAction = async () => {
        if (action === 'delete') {
            setConfirmDialogOpen(true);
            return;
        }
        if (action === 'status') {
            setLoading(true);
            const actionDomains = selectedDomains.length > 0
                ? allSelectedDomains.filter(domain => selectedDomains.includes(domain.id))
                : allSelectedDomains;

            try {
                const domainPayload = {};
                actionDomains.forEach(domain => {
                    const d = actionDomains.find((elem) => elem.urlToMonitor === domain.urlToMonitor)
                    domainPayload[domain.urlToMonitor || domain.domainName] = {
                        "region": d.uptime_settings?.regions || [{ "city": "toronto", "country": "ca" }, { "city": "shenzhen", "country": "cn" }],
                        "follow_redirect": d.uptime_settings?.followRedirect || false,
                        "timeout": (d.uptime_settings?.requestTimeout || 20) * 1000,
                    }
                });

                const requestBody = {
                    domain: domainPayload,
                    timeout: 20000,
                };

                try {
                    const response = await fetch('https://seomanager.ahaspeed.com/domains/status', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(requestBody),
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    const resultData = await response.json();
                    processResults(resultData.result);
                } catch (error) {
                    console.error(`Error checking live status:`, error);
                }
            } catch (error) {
                console.error("Error processing domains:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const processResults = (results) => {
        const defaultUpStatuses = ["2xx", "3xx"];
        const downDomainsByRegion = {};
        const upDomainsByRegion = {};

        Object.entries(results).forEach(([domainUrl, domainData]) => {
            Object.entries(domainData || {}).forEach(([regionKey, regionData]) => {
                if (!regionData || typeof regionData !== 'object' || regionData.status_code == null) {
                    console.warn(`Skipping region ${regionKey} for domain ${domainUrl} due to missing or invalid status_code`);
                    return;
                }

                const statusPrefix = Math.floor(regionData.status_code / 100);
                const statusString = `${statusPrefix}xx`;

                if (defaultUpStatuses.includes(statusString)) {
                    upDomainsByRegion[regionKey] = upDomainsByRegion[regionKey] || [];
                    upDomainsByRegion[regionKey].push({
                        domainName: domainUrl,
                        regionKey,
                        responseTime: regionData.response_time,
                    });
                } else {
                    downDomainsByRegion[regionKey] = downDomainsByRegion[regionKey] || [];
                    downDomainsByRegion[regionKey].push({
                        domainName: domainUrl,
                        regionKey,
                        status: regionData.status_code,
                    });
                }
            });
        });

        const torontoUpDomains = upDomainsByRegion['ca_toronto'] || [];
        const torontoDownDomains = downDomainsByRegion['ca_toronto'] || [];
        const totalUp = torontoUpDomains.length;
        const totalDown = torontoDownDomains.length;
        const totalDomains = Object.keys(results).length;

        showStatusSummaryPopup(
            totalDomains,
            totalUp,
            totalDown,
            torontoDownDomains,
            torontoUpDomains,
            downDomainsByRegion,
            upDomainsByRegion
        );
    };

    const showStatusSummaryPopup = (totalDomains, totalUp, totalDown, downDomains, upDomains, downDomainsByRegion, upDomainsByRegion) => {
        const summary = {
            totalDomains,
            totalUp,
            totalDown,
            downDomainsByRegion,
            upDomainsByRegion,
        };
        setSummaryData(summary);
        setOpenPopup(true);
    };

    const handleRegionChange = (region) => {
        setSelectedRegion(region);
        setLoading(true);
        const downDomainsInRegion = summaryData?.downDomainsByRegion?.[region] || [];
        const upDomainsInRegion = summaryData?.upDomainsByRegion?.[region] || [];

        if (downDomainsInRegion.length > 0) {
            setSelectedTab(1);
        } else if (upDomainsInRegion.length > 0) {
            setSelectedTab(0);
        }

        const totalDomains = downDomainsInRegion.length + upDomainsInRegion.length;
        showStatusSummaryPopup(
            totalDomains,
            upDomainsInRegion.length,
            downDomainsInRegion.length,
            downDomainsInRegion,
            upDomainsInRegion,
            summaryData.downDomainsByRegion,
            summaryData.upDomainsByRegion
        );
        setLoading(false);
    };

    useEffect(() => {
        if (summaryData) {
            const downDomainsInRegion = summaryData?.downDomainsByRegion?.[selectedRegion] || [];
            const upDomainsInRegion = summaryData?.upDomainsByRegion?.[selectedRegion] || [];
            if (downDomainsInRegion.length > 0) {
                setSelectedTab(1);
            } else if (upDomainsInRegion.length > 0) {
                setSelectedTab(0);
            }
        }
    }, [summaryData, selectedRegion]);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleCancelDelete = () => {
        setDomainToDelete(null);
        setConfirmDialogOpen(false);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleSelectAllCurrentPage = (isSelected) => {
        if (isSelected) {
            const currentDomainIds = domains.map(domain => domain.id);
            setSelectedDomains([...selectedDomains, ...currentDomainIds]);
        } else {
            const currentDomainIds = domains.map(domain => domain.id);
            setSelectedDomains(selectedDomains.filter(id => !currentDomainIds.includes(id)));
        }
    };

    const handleSelectAllAcrossPages = async () => {
        setAllSelected(true);
        const allDomainIds = await fetchAllDomainIds();
        setSelectedDomains(allDomainIds);
    };

    const handleResetSelection = () => {
        setSelectedDomains([]);
        setAllSelected(false);
    };

    const handleDuplicate = (domainId) => {
        navigate(`/dashboard/domains/duplicate/${domainId}`, { state: { isDuplicate: true } });
    };

    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortOrder === 'asc';
        const newSortOrder = isAsc ? 'desc' : 'asc';

        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set('sortColumn', column);
        queryParams.set('sortOrder', newSortOrder);
        // queryParams.set('page', 1);

        navigate(`../domains?${queryParams.toString()}`);
        setSortOrder(newSortOrder);
        setSortColumn(column);
    };

    // const filteredDomains = domains.filter(domain => {
    //     const keywordNames = domain.keywords ? domain.keywords.map(keyword => keyword.name).join(', ') : '';
    //     return domain.domainName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //         keywordNames.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //         domain.projectName.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
    //         domain.template.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
    //         domain.siteTitle.toLowerCase().includes(searchTerm.toLowerCase());
    // });

    // const sortedDomains = filteredDomains.sort((a, b) => {
    //     if (sortColumn === 'creationTime') {
    //         return sortOrder === 'asc' ? a[sortColumn] - b[sortColumn] : b[sortColumn] - a[sortColumn];
    //     } else {
    //         let aValue = a[sortColumn] ? a[sortColumn].toLowerCase() : '';
    //         let bValue = b[sortColumn] ? b[sortColumn].toLowerCase() : '';
    //         if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
    //         if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
    //         return 0;
    //     }
    //     return 0;
    // });

    // const startIndex = currentPage * rowsPerPage;
    // const endIndex = startIndex + rowsPerPage;
    // const paginatedDomains = sortedDomains.slice(startIndex, endIndex);

    return (
        <Container maxWidth={false} sx={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>
            <Box container spacing={2} alignItems="center" sx={{ paddingTop: '10px', marginBottom: '20px' }}>
                <Box item xs={4}>
                    <Typography variant="h5" gutterBottom paddingLeft={"2px"}>
                        Domains
                    </Typography>
                </Box>
            </Box>
            <Paper elevation={3} sx={{ padding: '20px', marginBottom: '20px', marginTop: '20px' }}>
                <Box
                    sx={{
                        position: 'absolute',
                        backgroundColor: '#D81B60',
                        width: '35px',
                        height: '35px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '8px',
                        boxShadow: 3,
                    }}>
                    <SearchIcon sx={{ fontSize: 30, color: '#fff' }} />
                </Box>
                <Box container spacing={2} alignItems="center">
                    <Box item xs={12} sx={{ paddingLeft: '45px' }}>
                        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold' }}>
                            Search
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '16px',
                        marginTop: '15px'
                    }}
                >
                    <TextField
                        fullWidth
                        label="Search Domain"
                        variant="standard"
                        value={domainInput}
                        onChange={(e) => setDomainInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    <TextField
                        fullWidth
                        label="Search User Email"
                        variant="standard"
                        value={userEmailInput}
                        onChange={(e) => setUserEmailInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    {/* <TextField
                        fullWidth
                        label="Search Keyword"
                        variant="standard"
                        value={keywordInput}
                        onChange={(e) => setKeywordInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    <TextField
                        fullWidth
                        label="Search Project"
                        variant="standard"
                        value={projectInput}
                        onChange={(e) => setProjectInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    <TextField
                        fullWidth
                        label="Search Template"
                        variant="standard"
                        value={templateInput}
                        onChange={(e) => setTemplateInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    /> */}
                    <TextField
                        fullWidth
                        label="From (Creation Time)"
                        variant="standard"
                        type="date"
                        slotProps={{
                            inputLabel: { shrink: true },
                        }}
                        value={creationTimeFromInput || ''}
                        onChange={(e) => {
                            setCreationTimeFromInput(e.target.value);
                            // Reset error if new From date makes sense
                            if (new Date(e.target.value) <= new Date(creationTimeTo)) {
                                setDateError('');
                            }
                        }}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    <TextField
                        fullWidth
                        label="To (Creation Time)"
                        variant="standard"
                        type="date"
                        slotProps={{
                            inputLabel: { shrink: true },
                        }}
                        value={creationTimeToInput || ''}
                        helperText={
                            dateError ? (
                                <span style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>
                                    <ErrorOutlineIcon sx={{ fontSize: '16px', marginRight: '2px' }} />
                                    {dateError}
                                </span>
                            ) : null
                        }
                        onChange={(e) => {
                            const toDate = new Date(e.target.value);
                            const fromDate = new Date(creationTimeFromInput);
                            if (toDate < fromDate) {
                                setDateError('To date > From date');
                            } else {
                                setDateError('');
                            }
                            setCreationTimeToInput(e.target.value);
                        }}
                        error={Boolean(dateError)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                </Box>
                <Box sx={{ display: 'flex', gap: '16px', marginTop: '20px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={handleSearch}
                        sx={{ minWidth: '100px', fontWeight: "bold" }}
                    >
                        Search
                    </Button>

                    <Button
                        variant="outlined"
                        color="secondary"
                        size="large"
                        onClick={() => {
                            // Clear all filter values
                            setDomainSearch('');
                            setUserEmailSearch('');
                            setKeywordSearch('');
                            setProjectSearch('');
                            setTemplateSearch('');
                            setSiteNameSearch('');
                            setCreationTimeFrom('');
                            setCreationTimeTo('');
                            setCreationTimeFromInput('');
                            setCreationTimeToInput('');
                            setDateError('');
                            navigate("/dashboard/domains");
                            // Refetch the data
                            fetchData({
                                lastVisible: null,
                                firstVisible: null,
                                rowsPerPage,
                                filters: {}
                            });
                        }}
                        sx={{ minWidth: '100px', fontWeight: "bold" }}
                    >
                        Reset
                    </Button>
                </Box>
            </Paper>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 20, marginLeft: 5 }}>
                <FormControl variant="standard" style={{ marginRight: 10, minWidth: 150 }}>
                    <InputLabel id="action-label" shrink={true} sx={{ fontSize: '1.1rem', paddintLeft: '15px' }}>Action</InputLabel>
                    <Select
                        labelId="action-label"
                        value={action}
                        onChange={(e) => setAction(e.target.value)}
                        sx={{ width: 170, height: 28 }}
                    >
                        <MenuItem value=""><em>None</em></MenuItem>
                        <MenuItem value="status">Check Live Status</MenuItem>
                        <MenuItem value="delete">Delete</MenuItem>
                    </Select>
                </FormControl>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleApplyAction}
                    disabled={selectedDomains.length === 0 || action === ''}
                    sx={{ height: 42 }}
                >
                    Apply
                </Button>
            </div>
            <div>
                {selectedDomains.length === domains.length && !allSelected && (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        p={0.7}
                        bgcolor="background.paper"
                        sx={{
                            flexDirection: { xs: "column", sm: "row" },
                            textAlign: "center",
                            mt: { xs: 2, sm: 0 }
                        }}
                    >
                        <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                            All <strong>{domains.length}</strong> domains on this page are selected.
                        </Typography>
                        {domains.length !== totalCount && (
                            <Button
                                variant="text"
                                color="primary"
                                onClick={handleSelectAllAcrossPages}
                                sx={{ fontSize: "1.1rem", paddingLeft: "10px", textTransform: "none", mt: { xs: 0, sm: 0 } }}
                            >
                                Select all {totalCount} domains across all pages
                            </Button>
                        )}
                    </Box>
                )}
                {allSelected && (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        p={0.7}
                        bgcolor="background.paper"
                        sx={{
                            flexDirection: { xs: "column", sm: "row" },
                            textAlign: "center",
                            mt: { xs: 2, sm: 0 }
                        }}
                    >
                        <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                            You have selected all <strong>{totalCount}</strong> domains.
                        </Typography>
                        <Button
                            variant="text"
                            color="secondary"
                            onClick={handleResetSelection}
                            sx={{ fontSize: "1.1rem", paddingLeft: "10px", textTransform: "none", mt: { xs: 0, sm: 0 } }}
                        >
                            Clear Selection
                        </Button>
                    </Box>
                )}
            </div>
            {
                loading ? (
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                ) : (
                    <Dialog
                        open={openPopup}
                        onClose={() => {
                            setOpenPopup(false);
                            setSelectedRegion("ca_toronto");
                            setSelectedTab(1);
                        }}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="h6" component="span">
                                Live Status Summary
                            </Typography>
                            <ToggleButtonGroup
                                value={selectedRegion}
                                exclusive
                                onChange={(_, newRegion) => {
                                    if (newRegion) {
                                        handleRegionChange(newRegion);
                                    }
                                }}
                                aria-label="region toggle"
                                sx={{ marginTop: 1 }}
                            >
                                {Object.keys(summaryData?.upDomainsByRegion || {})
                                    .concat(Object.keys(summaryData?.downDomainsByRegion || {}))
                                    .filter((region, index, self) => self.indexOf(region) === index)
                                    .map((regionKey) => {
                                        const [country, city] = regionKey.split('_');
                                        const formattedRegion = `${city.charAt(0).toUpperCase() + city.slice(1).toLowerCase()}, ${country}`;
                                        return (
                                            <ToggleButton
                                                key={regionKey}
                                                value={regionKey}
                                                sx={{
                                                    padding: '4px 8px',
                                                    '&.Mui-selected': {
                                                        backgroundColor: 'primary.main',
                                                        color: 'white',
                                                    },
                                                }}
                                            >
                                                {formattedRegion}
                                            </ToggleButton>
                                        );
                                    })}
                            </ToggleButtonGroup>
                        </DialogTitle>
                        <DialogContent>
                            <Box container spacing={2} sx={{ marginTop: 0.1, display: 'flex', justifyContent: 'space-between' }}>
                                {/* Domain Summary */}
                                <Box item xs={4} style={{ textAlign: 'center', flex: 1, margin: '0 8px' }}>
                                    <Typography variant="subtitle1" style={{ backgroundColor: '#f0f0f0', padding: '10px' }}>
                                        Total Domains
                                    </Typography>
                                    <Typography variant="h5" component="div" fontWeight="bold">
                                        {summaryData?.totalDomains}
                                    </Typography>
                                </Box>
                                <Box item xs={4} style={{ textAlign: 'center', flex: 1, margin: '0 8px' }}>
                                    <Typography variant="subtitle1" style={{ backgroundColor: '#d4edda', padding: '10px' }}>
                                        Domains Up
                                    </Typography>
                                    <Typography variant="h5" component="div" fontWeight="bold">
                                        {summaryData?.totalUp}
                                    </Typography>
                                </Box>
                                <Box item xs={4} style={{ textAlign: 'center', flex: 1, margin: '0 8px' }}>
                                    <Typography variant="subtitle1" style={{ backgroundColor: '#f8d7da', padding: '10px' }}>
                                        Domains Down
                                    </Typography>
                                    <Typography variant="h5" component="div" fontWeight="bold">
                                        {summaryData?.totalDown}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Tabs for Domain Status */}
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '20px' }}>
                                <Tabs value={selectedTab} onChange={(_, newTab) => setSelectedTab(newTab)} variant="fullWidth">
                                    <Tab label="Domains Up" />
                                    <Tab label="Domains Down" />
                                </Tabs>
                            </Box>
                            {selectedTab === 0 && (
                                <div style={{ marginTop: '10px' }}>
                                    {summaryData?.upDomainsByRegion?.[selectedRegion]?.length > 0 ? (
                                        <TableContainer style={{ maxHeight: '380px', maxWidth: '900px', overflowX: 'hidden', marginTop: '10px', scrollbarWidth: 'thin' }}>
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>#</TableCell>
                                                        <TableCell style={{ textAlign: 'center', fontSize: '1.0rem' }}>Region</TableCell>
                                                        <TableCell style={{ textAlign: 'center', fontSize: '1.0rem' }}>
                                                            Res.Time (ms)
                                                        </TableCell>
                                                        <TableCell style={{ fontSize: '1.0rem' }}>Domain Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(summaryData?.upDomainsByRegion[selectedRegion] || []).map((domain, index) => (
                                                        <TableRow key={domain.domainName}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{selectedRegion}</TableCell>
                                                            <TableCell>
                                                                <Box
                                                                    sx={{
                                                                        backgroundColor: '#28a745',
                                                                        color: 'white',
                                                                        padding: '5px 5px',
                                                                        borderRadius: '20px',
                                                                        textAlign: 'center',
                                                                        fontWeight: 'bold',
                                                                    }}
                                                                >
                                                                    {domain.responseTime}
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell>
                                                                <a href={domain.domainName} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#3f51b5' }}>
                                                                    {domain.domainName}
                                                                </a>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    ) : (
                                        <Typography variant="h6" align="center" color="textSecondary">
                                        </Typography>
                                    )}
                                </div>
                            )}
                            {selectedTab === 1 && (
                                <div style={{ marginTop: '10px' }}>
                                    {summaryData?.downDomainsByRegion?.[selectedRegion]?.length > 0 ? (
                                        <TableContainer style={{ maxHeight: '380px', maxWidth: '900px', overflowX: 'hidden', marginTop: '10px', scrollbarWidth: 'thin' }}>
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>#</TableCell>
                                                        <TableCell style={{ textAlign: 'center', fontSize: '1.0rem' }}>Region</TableCell>
                                                        <TableCell style={{ textAlign: 'center', fontSize: '1.0rem', width: '20%' }}>Status</TableCell>
                                                        <TableCell style={{ width: '70%', fontSize: '1.0rem' }}>Domain Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(summaryData?.downDomainsByRegion[selectedRegion] || []).map((domain, index) => (
                                                        <TableRow key={domain.domainName}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{selectedRegion}</TableCell>
                                                            <TableCell>
                                                                <Box
                                                                    sx={{
                                                                        backgroundColor: '#f44336',
                                                                        color: 'white',
                                                                        padding: '5px 5px',
                                                                        borderRadius: '20px',
                                                                        textAlign: 'center',
                                                                        fontWeight: 'bold',
                                                                    }}
                                                                >
                                                                    {domain.status}
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell>
                                                                <a href={domain.domainName} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#3f51b5' }}>
                                                                    {domain.domainName}
                                                                </a>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    ) : (
                                        <Typography variant="h6" align="center" color="textSecondary">
                                        </Typography>
                                    )}
                                </div>
                            )}

                            {/* Auto-Switch to Up Domains if None Down */}
                            {selectedTab === 1 && !summaryData?.downDomainsByRegion?.[selectedRegion]?.length && summaryData?.upDomainsByRegion?.[selectedRegion]?.length > 0 && (
                                <Typography variant="h6" align="center" color="textSecondary" paddingTop={2}>
                                    You don't have any domains <span style={{ color: 'red' }}>Down</span>.
                                </Typography>
                            )}

                            {selectedTab === 0 && !summaryData?.upDomainsByRegion?.[selectedRegion]?.length && (
                                <Typography variant="h6" align="center" color="textSecondary" paddingTop={2}>
                                    You don't have any domains <span style={{ color: 'green' }}> Up </span>.
                                </Typography>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => { setOpenPopup(false); setSelectedTab(1); setSelectedRegion("ca_toronto"); }}>Close</Button>
                        </DialogActions>
                    </Dialog>
                )
            }
            {
                loading ? (
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                ) : (
                    <TableContainer component={Paper} sx={{ marginTop: '20px', overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" padding="checkbox">
                                        <Checkbox
                                            style={{ padding: 0 }}
                                            indeterminate={(selectedDomains.length > 0 && selectedDomains.length < paginatedDomains?.length) || (selectedDomains.length > paginatedDomains?.length && selectedDomains.length < totalCount)}
                                            checked={allSelected || (paginatedDomains?.length > 0 && selectedDomains.length >= paginatedDomains?.length)}
                                            onChange={(e) => {
                                                if (selectedDomains.length > 0 && selectedDomains.length < paginatedDomains?.length) {
                                                    setSelectedDomains([]);
                                                    setAllSelected(false);
                                                } else {
                                                    if (e.target.checked) {
                                                        setSelectedDomains(paginatedDomains?.map((domain) => domain.id));
                                                    } else {
                                                        setSelectedDomains([]);
                                                        setAllSelected(false);
                                                    }
                                                }
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell style={{ paddingLeft: '23px' }}>
                                        <TableSortLabel
                                            active={sortColumn === 'domainName'}
                                            direction={sortOrder}
                                            onClick={() => handleSort('domainName')}
                                            sx={{ fontWeight: "bold" }}
                                        >
                                            Domain
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>
                                        <TableSortLabel
                                            active={sortColumn === 'userEmail'}
                                            direction={sortOrder}
                                            onClick={() => handleSort('userEmail')}
                                            sx={{ fontWeight: "bold" }}
                                        >
                                            User Email
                                        </TableSortLabel>
                                    </TableCell>
                                    {/* <TableCell sx={{ fontWeight: "bold" }}>Keyword</TableCell>
                                    <TableCell>
                                        <TableSortLabel
                                            active={sortColumn === 'projectName'}
                                            direction={sortOrder}
                                            onClick={() => handleSort('projectName')}
                                            sx={{ fontWeight: "bold" }}
                                        >
                                            Project
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell>
                                        <TableSortLabel
                                            active={sortColumn === 'template'}
                                            direction={sortOrder}
                                            onClick={() => handleSort('template')}
                                            sx={{ fontWeight: "bold" }}
                                        >
                                            Template
                                        </TableSortLabel>
                                    </TableCell> */}
                                    <TableCell sx={{ fontWeight: "bold" }}>
                                        Live Status
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>Monitor Status</TableCell>
                                    <TableCell>
                                        <TableSortLabel
                                            active={sortColumn === 'creationTime'}
                                            direction={sortOrder}
                                            onClick={() => handleSort('creationTime')}
                                            sx={{ fontWeight: "bold" }}
                                        >
                                            Creation Time
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontWeight: "bold" }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedDomains?.map(domain => (
                                    <TableRow key={domain.id} selected={selectedDomains.includes(domain.id)}>
                                        <TableCell align="center" padding="checkbox">
                                            <Checkbox
                                                checked={selectedDomains.includes(domain.id)}
                                                onChange={(e) => {
                                                    const selectedIndex = selectedDomains?.indexOf(domain.id);
                                                    let newSelected = [];
                                                    if (selectedIndex === -1) {
                                                        newSelected = newSelected.concat(selectedDomains, domain.id);
                                                    } else if (selectedIndex === 0) {
                                                        newSelected = newSelected.concat(selectedDomains.slice(1));
                                                    } else if (selectedIndex === selectedDomains.length - 1) {
                                                        newSelected = newSelected.concat(selectedDomains.slice(0, -1));
                                                    } else if (selectedIndex > 0) {
                                                        newSelected = newSelected.concat(
                                                            selectedDomains.slice(0, selectedIndex),
                                                            selectedDomains.slice(selectedIndex + 1),
                                                        );
                                                    }
                                                    if (newSelected.length < totalCount) {
                                                        setAllSelected(false);
                                                    } else if (newSelected.length = totalCount) {
                                                        setAllSelected(true);
                                                    }
                                                    setSelectedDomains(newSelected);
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="left" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            <span style={{ display: 'inline-block', textAlign: 'left', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                <a
                                                    href={
                                                        domain.domainName.startsWith('http://') || domain.domainName.startsWith('https://')
                                                            ? domain.domainName
                                                            : `https://${domain.domainName}`
                                                    }
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    {domain.domainName}
                                                </a>
                                            </span>
                                        </TableCell>
                                        <TableCell>{domain.userEmail}</TableCell>
                                        {/* <TableCell>
                                            {domain.keywords.map((keyword, index) => (
                                                <span key={keyword.name}>
                                                    {keyword.name}
                                                    <br />
                                                </span>
                                            ))}
                                        </TableCell>
                                        <TableCell>
                                            {domain.projectName}
                                        </TableCell>
                                        <TableCell>
                                            {domain.template}
                                        </TableCell> */}
                                        <TableCell style={{ position: 'relative' }}>
                                            <Tooltip
                                                title={
                                                    Object.entries(domainStatuses[hoveredDomainId]?.regionStatuses || {}).map(
                                                        ([regionKey, regionStatus]) => (
                                                            <Box
                                                                key={regionKey}
                                                                display="flex"
                                                                alignItems="center"
                                                                sx={{
                                                                    padding: 0.5,
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 'bold',
                                                                        color: 'primary.main',
                                                                        marginRight: 1,
                                                                    }}
                                                                >
                                                                    {regionKey}:
                                                                </Typography>
                                                                {regionStatus ? (
                                                                    <>
                                                                        {regionStatus.status === 'Online' ? (
                                                                            <CheckCircle
                                                                                sx={{
                                                                                    color: 'success.main',
                                                                                    fontSize: 16,
                                                                                    marginRight: 0.5,
                                                                                }}
                                                                            />
                                                                        ) : regionStatus.status === 'Offline' ? (
                                                                            <Cancel
                                                                                sx={{
                                                                                    color: 'error.main',
                                                                                    fontSize: 16,
                                                                                    marginRight: 0.5,
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <Info
                                                                                sx={{
                                                                                    color: 'gray',
                                                                                    fontSize: 16,
                                                                                    marginRight: 0.5,
                                                                                }}
                                                                            />
                                                                        )}
                                                                        <Typography variant="body2" sx={{ color: regionStatus.color }}>
                                                                            {regionStatus.status}
                                                                        </Typography>
                                                                    </>
                                                                ) : (
                                                                    <Typography variant="body2" color="textSecondary">
                                                                        N/A
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        )
                                                    )
                                                }
                                                arrow
                                                open={tooltipVisible && hoveredDomainId === domain.id}
                                                onOpen={() => !tooltipVisible && setHoveredDomainId(domain.id)}
                                                onClose={() => tooltipVisible && setHoveredDomainId(null)}
                                                PopperProps={{
                                                    sx: {
                                                        '& .MuiTooltip-tooltip': {
                                                            backgroundColor: '#f5f5f9',
                                                            color: 'text.primary',
                                                            boxShadow: 'none',
                                                        },
                                                    },
                                                }}
                                            >
                                                <Button
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        border: 'none',
                                                        padding: 0,
                                                        background: 'none',
                                                        cursor: 'pointer',
                                                        outline: 'none',
                                                    }}
                                                    onClick={() => handleStatusClick(domain)}
                                                    onMouseEnter={() => setTooltipVisible(true)}
                                                    onMouseLeave={() => setTooltipVisible(false)}
                                                >
                                                    {domainStatuses[domain.id]?.status === 'loading' ? (
                                                        <CircularProgress size={24} />)
                                                        : (
                                                            <>
                                                                {domainStatuses[domain.id]?.upCount < domainStatuses[domain.id]?.totalRegions ? (
                                                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
                                                                        <StatusIndicator color='red' />
                                                                        <span style={{ textTransform: 'none' }}>
                                                                            {`${domainStatuses[domain.id]?.upCount || 0}/${domainStatuses[domain.id]?.totalRegions || 0}`}
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
                                                                        <StatusIndicator color='green' />
                                                                        <span style={{ textTransform: 'none' }}>
                                                                            {`${domainStatuses[domain.id]?.upCount || 0}/${domainStatuses[domain.id]?.totalRegions || 0}`}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                </Button>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            {domain.uptime_settings.isPaused === false ? (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <StatusIndicator color='green' msg='Yes' />
                                                </div>
                                            ) : (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <StatusIndicator color='red' msg='No' />
                                                </div>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {domain.creationTime && moment(domain.creationTime).format('YYYY-MM-DD HH:mm')}
                                        </TableCell>
                                        <TableCell align="center">
                                            {isMobile ? (
                                                <>
                                                    <Button
                                                        size="small"
                                                        color="inherit"
                                                        href={domain.domainName}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        startIcon={<OpenInNewIcon />}
                                                        style={{
                                                            padding: 0,
                                                            margin: 0,
                                                            minWidth: 'auto',
                                                            width: 'auto',
                                                            height: 'auto',
                                                            boxShadow: 'none',
                                                            textTransform: 'none'
                                                        }}
                                                    >
                                                    </Button>
                                                    <Button
                                                        size="small"
                                                        color="secondary"
                                                        onClick={() => {
                                                            setDomainToDelete(domain.id);
                                                            setConfirmDialogOpen(true);
                                                        }}
                                                        startIcon={<Delete />}
                                                    >
                                                        Delete
                                                    </Button>
                                                </>
                                            ) : (
                                                <Box sx={{ display: 'flex', gap: '2px' }}>
                                                    <Button
                                                        size="small"
                                                        color="inherit"
                                                        href={domain.domainName}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        startIcon={<OpenInNewIcon />}
                                                        style={{
                                                            padding: 0,
                                                            margin: 0,
                                                            minWidth: 'auto',
                                                            width: 'auto',
                                                            height: 'auto',
                                                            boxShadow: 'none',
                                                            textTransform: 'none'
                                                        }}
                                                    >
                                                    </Button>
                                                    <Button
                                                        size="small"
                                                        color="secondary"
                                                        onClick={() => {
                                                            setDomainToDelete(domain.id);
                                                            setConfirmDialogOpen(true);
                                                        }}
                                                        startIcon={<Delete />}
                                                        sx={{ fontWeight: "bold" }}
                                                    >
                                                        Delete
                                                    </Button>
                                                </Box>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )
            }
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 5, marginBottom: 20, overflow: 'hidden', flexDirection: window.innerWidth < 600 ? 'column' : 'row' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleApplyAction}
                    disabled={selectedDomains.length === 0 || action === ''}
                    style={{
                        marginTop: window.innerWidth < 600 ? '20px' : '0',
                        marginLeft: window.innerWidth < 600 ? '5px' : '0',
                        alignSelf: window.innerWidth < 600 ? 'flex-start' : 'center'
                    }}
                >
                    Apply
                </Button>
                <div style={{ flexGrow: 1 }} />
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={Math.min(page, Math.floor(totalCount / rowsPerPage))}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    style={{ paddingBottom: '20px', paddingTop: '10px', overflow: 'hidden' }}
                />
            </div>
            <ConfirmationDialog
                open={confirmDialogOpen}
                handleClose={handleCancelDelete}
                handleConfirm={handleConfirmDelete}
            />
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{ mt: 7, mr: 1 }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbarMessage.includes('successfully') ? 'success' : 'error'} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isDeleting}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Container >
    );
};

export default Domains;
